package top.wcpe.allincore.dsl.ir.model

import top.wcpe.allincore.dsl.ir.model.internal.ReadOnlyOrderedMap

/**
 * UiNode 上的一项有序视觉 modifier。
 *
 * 字段名保持 DSL 内部名，例如 `shadow.offsetY` 在本对象中表现为
 * kind=`shadow`, fields["offsetY"]。普通视觉简写字段聚合到 kind=`style`。
 */
class UiModifier(kind: String, fields: Map<String, UiBinding>) {

    // val 属性生成 getKind() / getFields()，与原 Java getter 名一致。
    val kind: String = requireNotNull(kind) { "kind" }
    val fields: Map<String, UiBinding>

    init {
        requireNotNull(fields) { "fields" }
        // 构造期校验 kind 可编码，避免坏数据延迟到 codec 阶段。
        ModifierOpcodes.kindToOpcode(this.kind)
        val copied = LinkedHashMap<String, UiBinding>(fields.size)
        for (e in fields.entries) {
            copied[requireNotNull(e.key) { "modifier field key" }] =
                requireNotNull(e.value) { "modifier field value" }
        }
        // 复刻原 Java Collections.unmodifiableMap 语义：保序 + Java 侧 put/remove 抛 UnsupportedOperationException。
        this.fields = ReadOnlyOrderedMap(copied)
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiModifier) return false
        return kind == other.kind && fields == other.fields
    }

    // 逐位复刻 Objects.hash(kind, fields)：种子 1、31 倍累乘。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + kind.hashCode()
        result = 31 * result + fields.hashCode()
        return result
    }

    override fun toString(): String = "UiModifier{" + kind + ", fields=" + fields.keys + "}"
}
